import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosButton } from './button'
import { IcosButtonGroup } from './button-group'


@NgModule({
  declarations: [IcosButton, IcosButtonGroup],
  exports: [IcosButton, IcosButtonGroup],
  imports: [CommonModule],
  entryComponents: [IcosButton, IcosButtonGroup],
})
export class IcosButtonsModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosButtonsModule, providers: [] }
  }
}
